<div *ngIf="result">
    <div><strong>Träger: </strong><span (click)="onClickGo()" class="goLink">{{result.name}}</span></div>
</div>
